var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12 mx-auto"},[_c('v-img',{attrs:{"aspect-ratio":"1","src":_vm.value,"width":"1000"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }